import api from './api';

export const questionnaireService = {
  async fetchQuestionnaires() {
    try {
      const response = await api.get('/questionnaires/list');
      return response.data;
    } catch (error) {
      this.handleError(error);
      throw error;
    }
  },

  async deleteQuestionnaire(id) {
    try {
      await api.delete(`/questionnaires/${id}`);
    } catch (error) {
      this.handleError(error);
      throw error;
    }
  },

  async assignQuestionnaire(id) {
    try {
      const response = await api.post(`/questionnaires/${id}/assign`);
      return response.data;
    } catch (error) {
      this.handleError(error);
      throw error;
    }
  },
  
  handleError(error) {
    // Centralized error handling
    console.error('API Error:', error);
    if (error.response) {
      // Server responded with error
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
    } else if (error.request) {
      // Request made but no response
      console.error('No response received');
    } else {
      // Error in request configuration
      console.error('Error:', error.message);
    }
  }
};